/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Recent system activity
 * @export
 * @interface WebApiAdminDtoRecentActivityDto
 */
export interface WebApiAdminDtoRecentActivityDto {
    /**
     * Number of user logins today
     * @type {number}
     * @memberof WebApiAdminDtoRecentActivityDto
     */
    userLoginsToday?: number;
    /**
     * Number of user logins this week
     * @type {number}
     * @memberof WebApiAdminDtoRecentActivityDto
     */
    userLoginsThisWeek?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoRecentActivityDto interface.
 */
export function instanceOfWebApiAdminDtoRecentActivityDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoRecentActivityDtoFromJSON(json: any): WebApiAdminDtoRecentActivityDto {
    return WebApiAdminDtoRecentActivityDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoRecentActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoRecentActivityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userLoginsToday': !exists(json, 'userLoginsToday') ? undefined : json['userLoginsToday'],
        'userLoginsThisWeek': !exists(json, 'userLoginsThisWeek') ? undefined : json['userLoginsThisWeek'],
    };
}

export function WebApiAdminDtoRecentActivityDtoToJSON(value?: WebApiAdminDtoRecentActivityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userLoginsToday': value.userLoginsToday,
        'userLoginsThisWeek': value.userLoginsThisWeek,
    };
}

